<template>
<!-- FINAL ICARE -->

<div class="wrapper">
  <div>
       <CButton  color="info" @click="openNew"><b>Add New Event</b></CButton>
        <mdb-calendar :events="events" />
      <CRow class="mt-3">
        <div>       
        </div>
      <CCol sm="12">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <Datatable 
                            :items="items" 
                            :fields="fields" 
                            :meta="meta" 
                            @per_page="handlePerPage" 
                            @pagination="handlePagination" 
                            @search="handleSearch" 
                            @sort="handleSort"
                            @is_active="handleIsActive"
                            :btn_show="true"
                            :btn_edit="true"
                            :btn_deactivate="true"
                            :btn_reactivate="false"
                            :btn_delete="false"
                            @showEvent="handleShowEvent"
                            @editEvent="handleEditEvent"
                            @editEventDescription="handleEditEventDescription"
                            @changeToPublish="handlechangeToPublish"
                            @showRegistrationPage="handleShowRegistrationPage"
                            @showEventOrder="handleShowEventOrder"
                            @deactivate="handleDeactivate"
                            @reactivate="handleReactivate"
                            @cancelation="handleCancelation"
                            @reportAttendance="handleReportAttendance"
                        />
                    </div>
                </div>
            </div>
        </div>  
      </CCol>
    </CRow>

    <alertmodal></alertmodal>
    <cancelationmodal></cancelationmodal>
</div>
</div>
</template>

<script>
import Datatable from '@/components/datatables_event.vue'
import axios from 'axios';

import event from '@/services/event';

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';
import store from '@/store.js'

import cancelationmodal from './event_cancelation_modal.vue';

const token = localStorage.getItem('token');

export default {
  name: 'IcareTables',
  components: { Datatable, alertmodal, cancelationmodal },
   data () {
    return {
      events: [],
      largeModal: false,
      updateSubmit: false,
      fields: [
          {key: 'name', sortable: false, },
          {key: 'available', sortable: false},
          {key: 'datetime_event', sortable: false},
          {key: 'admission_fee', label: 'free/paid' ,sortable: false},
          {key: 'status', sortable: false},
          {key: 'action', label: 'Action', sortable: false},
      ],
      items: [],
      meta: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      is_active: 1,
    }
   },
   mounted (){
     this.loadData()

      var self = this;
      EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          self.loadData();
      }
    });
   },

  methods: {
     openNew: function () {
      this.$router.push({name:'Event Form'}) 
    },
    
    openShowEvent: function(id) {
      this.$router.push({name:'Event Detail',query: {id:id} }) 
    },

    openEditEvent(id){
      this.$router.push({name:'Event Form',query: {id:id} })      
    },

    openEditEventDescription(id){
      this.$router.push({name:'Event Form Description',query: {id:id} })      
    },

    changeToPublish(id){   
      if(confirm("Do you really want to publish this event?")){
        event.publishEvent(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
    },

    showRegistrationPage(id){
      let route = this.$router.resolve(
        {
        path: '/event-registration',
        //path: '/event-detail-test',
        query: {'id': id}
        });
      // let route = this.$router.resolve('/link/to/page'); // This also works.
      window.open(route.href, '_blank', "height=800,width=1000");      
    },

    showEventOrder(id){
      this.$router.push({name:'Event Order',query: {id:id} })    
    },

    deactivate(id){
      if(confirm("Do you really want to deactivate?")){
        event.deactivateEvent(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
    },

    reactivate(id){
      if(confirm("Do you really want to reactivate?")){
        event.reactivateEvent(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
    },

    cancelation(id){
      var self = this;
      if(confirm("Do you really want to cancel?")){

        var params = {title: 'Cancelation', mode:'', data:id}
        EventBus.$emit('OPEN_MODAL_EVENT_CANCELATION', params)

        //this.loadData();
        // event.cancelationEvent(id)
        // .then(res => {
        //   // EventBus.$emit('TABLE_UPDATE', true)
        //   self.loadData()
        //   var params = {title: 'Success', mode:'success', data:res.message}
        //   EventBus.$emit('OPEN_MODAL_ALERT', params)
        // }).catch ((err) => {
        //   var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        //   EventBus.$emit('OPEN_MODAL_ALERT', params)
        // })
      }  
    },

    reportAttendance(id){
      let route = this.$router.resolve(
        {
        path: '/reportview/event_attendance',
        query: {'id':id}
        });
      // let route = this.$router.resolve('/link/to/page'); // This also works.
      window.open(route.href, '_blank', "height=800,width=1000");
    },

    loadData() {
      let current_page = this.search == '' ? this.current_page:1
      var params = {
       
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
      }

      event.getEventDataSource(params)
      .then(res => {
          let getData = res.data
          this.items = getData.data
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },

    // openCamera(){
    //   // let route = this.$router.resolve(
    //   //   {
    //   //   path: '/event-camera',
    //   //   });
    //   // // let route = this.$router.resolve('/link/to/page'); // This also works.
    //   // window.open(route.href, '_blank', "height=800,width=1000");     
    //   this.$router.push({name:'Event Camera'})       
    // },

    //      openCamera: function () {
    //   this.$router.push({name:'Event Camera'}) 
    // },

    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
   handleShow(val) {
        this.openShow(val) 
    }, 
    handleShowEvent(val) {
        this.openShowEvent(val) 
    }, 
    handleEditEvent(val) {
        this.openEditEvent(val) 
    }, 
    handleEditEventDescription(val) {
        this.openEditEventDescription(val) 
    },
    handleShowRegistrationPage(val) {
        this.showRegistrationPage(val) 
    },  
    // handleShowEventOrder(val) {
    //     this.showEventOrder(val) 
    // },  
    handlechangeToPublish(val) {
        this.changeToPublish(val) 
    },    
    handleDeactivate(val) {
        this.deactivate(val)       
    },
    handleReactivate(val) {
        this.reactivate(val)       
    },   
    handleCancelation(val) {
        this.cancelation(val)       
    },
    handleReportAttendance(val) {
        this.reportAttendance(val)       
    },  

  }
}
</script>
